import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { createEmail } from '../actions/createEmail';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-orchestration';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PremiumDomainConnectSecondStep } from 'owa-domain-connect';
import store from '../store/store';
export default orchestrator(createEmail, function createEmail() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            traceCreateEmailButtonClick();
            hideFullOptions();
            mountDomainConnectSecondStep();
            return [2 /*return*/];
        });
    });
});
function mountDomainConnectSecondStep() {
    var dcSecondStepContainer = document.createElement('div');
    document.body.appendChild(dcSecondStepContainer);
    ReactDOM.render(React.createElement(PremiumDomainConnectSecondStep, { domainName: store.domainName, csrfToken: null, mountFromDomainDashBoard: true, onClose: function () { return document.body.removeChild(dcSecondStepContainer); } }), dcSecondStepContainer);
}
//# sourceMappingURL=createEmail.js.map